import type { AsyncThunk } from "@reduxjs/toolkit";
import { useState } from "react";
import { type NavigateFunction, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";

export const useDeleteModal = (
  deleteAction: AsyncThunk<any, { id: string; navigate: NavigateFunction }, any>
) => {
  const dispatch = useAppDispatch();
  const [deleteInfo, setDeleteInfo] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();

  const openDeleteModal = (id: string, name: string) => {
    setDeleteInfo({ id, name });
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteInfo({});
    setIsDeleteModalOpen(false);
  };

  const handleDelete = (id: string) => {
    closeDeleteModal();
    dispatch(deleteAction({ id, navigate }));
  };

  return {
    deleteInfo,
    isDeleteModalOpen,
    handleDelete,
    openDeleteModal,
    closeDeleteModal,
  };
};
